import React from "react";
import "./index.css";
import InfoIcon from "../InfoIcon";
import SystemBoundary from "./SystemBoundary";

const Scope = ({ scope, filled }) => (
  <span className={`scope ${filled ? "filled" : "outlined"}`}>{scope}</span>
);

const GraphicIcon = ({ icon }) => (
  <img src={icon} width={18} height={18} alt="Graphic Icon" />
);

const LeftBox = ({
  icon,
  title,
  description,
  scopes,
  show,
  graphicIcons,
  showInfoIcon,
  infoText,
  isSystemBoundary,
  systemBoundary,
  setSystemBoundary,
  businessId,
  totalObjCategory,
}) => {
  return (
    <div className="left-box">
      <div className="left-icon">{icon}</div>
      <div className="left-box-body">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingLeft: "3px",
          }}
        >
          <div style={{ display: "flex", position: "relative" }}>
            <h2>{title}</h2>
            {showInfoIcon && <InfoIcon text={infoText} />}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div className="scopes">
              {scopes?.map((scope, index) => (
                <Scope key={index} {...scope} />
              ))}
            </div>
            {graphicIcons && (
              <div className="graphic-icons">
                {graphicIcons?.map((icon, index) => (
                  <GraphicIcon key={index} {...icon} />
                ))}
              </div>
            )}
          </div>
        </div>
        <p
          style={{
            textOverflow: show ? "initial" : "ellipsis",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          {description}
        </p>
        {isSystemBoundary && (
          <div style={{ marginLeft: "20px" }}>
            <SystemBoundary
              systemBoundary={systemBoundary}
              setSystemBoundary={setSystemBoundary}
              businessId={businessId}
              totalObjCategory={totalObjCategory}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftBox;
